import { type OasisAssessmentViewModel } from '@generated';
import { OasisTabPdgm } from './OasisTabPdgm';
import { Section } from '~/shared/section/Section';
import { ButtonGroupField } from '~/shared/forms/controls/base-fields/ButtonGroupField';
import { useState } from 'react';
import { ChartArea, ClipboardList, List } from 'lucide-react';
import { OasisTabDetails } from './OasisTabDetails';
import { OasisTabNonClinicalDetails } from './OasisTabNonClinicalDetails';
import { SuspenseWrapper } from '~/shared/SuspenseWrapper';

const options = [
	{ id: 'pdgm', label: 'PDGM', Icon: ChartArea },
	{ id: 'detail', label: 'Detail', Icon: List },
	{ id: 'nonclinical', label: 'Non-clinical', Icon: ClipboardList }
];

export function OasisTab({ oasisAssessment }: { oasisAssessment: OasisAssessmentViewModel }) {
	const [selectedTab, setSelectedTab] = useState<string>('pdgm');
	return (
		<div className="flex flex-col gap-4">
			<Section>
				<div className="flex flex-row items-center justify-between">
					<div className="text-xs text-gray-600">
						<span className="font-medium">Assessed by:</span> {oasisAssessment.completingUser?.fullName ?? 'N/A'} &nbsp;·&nbsp;
						<span className="font-medium">Assessment date:</span>
						{oasisAssessment?.assessmentDate?.toLocaleDateString() ?? 'N/A'} &nbsp;·&nbsp;
						<span className="font-medium">Type: </span> {oasisAssessment.oasisAssessmentDefinition.name}
					</div>
					<ButtonGroupField
						onSelect={setSelectedTab}
						isSelected={id => id === selectedTab}
						options={options}
						label="Select View"
						hideLabel
					/>
				</div>
			</Section>
			{selectedTab === 'pdgm' && <OasisTabPdgm oasisAssessment={oasisAssessment} />}
			{selectedTab === 'detail' && (
				<SuspenseWrapper name="OasisTabDetails">
					<OasisTabDetails oasisAssessment={oasisAssessment} />
				</SuspenseWrapper>
			)}
			{selectedTab === 'nonclinical' && (
				<SuspenseWrapper name="OasisTabNonClinicalDetails">
					<OasisTabNonClinicalDetails oasisAssessment={oasisAssessment} />
				</SuspenseWrapper>
			)}
		</div>
	);
}
